import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FeaturesSection from './components/FeaturesSection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FeaturesSection />
        <LatestUpdates />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />

      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                name: 'aaa日韩',
                url: 'https://www.aaarihan.com',
                description: 'aaa日韩是探索日韩优质内容的首选平台，汇聚海量日韩正版资源。',
                email: 'support@aaarihan.com',
                telephone: '400-888-8888',
              },
              {
                '@type': 'WebSite',
                name: 'aaa日韩',
                url: 'https://www.aaarihan.com',
                description: 'aaa日韩官方入口·正版授权平台，提供日韩高清在线内容。',
                inLanguage: 'zh-CN',
              },
              {
                '@type': 'WebPage',
                name: 'aaa日韩 - 首页',
                url: 'https://www.aaarihan.com',
                description: 'aaa日韩官方入口·正版授权平台，汇聚海量日韩正版资源，高清流畅体验。',
                isPartOf: { '@id': 'https://www.aaarihan.com/#website' },
                about: { '@id': 'https://www.aaarihan.com/#organization' },
              },
              {
                '@type': 'FAQPage',
                mainEntity: [
                  {
                    '@type': 'Question',
                    name: 'aaa日韩平台是否需要注册才能观看？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: 'aaa日韩平台支持免费注册，注册后即可享受海量日韩正版内容。部分内容支持游客模式预览。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: 'aaa日韩支持哪些设备观看？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: 'aaa日韩支持全平台观看，包括网页端、手机端、平板端以及智能电视，观看记录自动同步。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: 'aaa日韩的内容更新频率如何？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: 'aaa日韩坚持每日更新，确保您能第一时间观看到最新的日韩影视、综艺、动漫和音乐内容。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: 'aaa日韩的视频画质如何？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: 'aaa日韩提供最高4K超高清画质，支持根据网络状况自动调整清晰度。',
                    },
                  },
                ],
              },
            ],
          }),
        }}
      />
    </>
  );
}